/** Errors the UI must handle distinctly. */
export class WrongPinError extends Error {
    attemptsLeft;
    constructor(attemptsLeft) {
        super(`Wrong PIN. ${attemptsLeft} attempt${attemptsLeft === 1 ? '' : 's'} left.`);
        this.attemptsLeft = attemptsLeft;
        this.name = 'WrongPinError';
    }
}
/** The user must sign in online (no PIN on this device yet, too many wrong PINs, or key rotated). */
export class NeedsOnlineLoginError extends Error {
    constructor(message = 'Please sign in with your username and password (internet needed).') {
        super(message);
        this.name = 'NeedsOnlineLoginError';
    }
}
export class WeakPinError extends Error {
    constructor(message) {
        super(message);
        this.name = 'WeakPinError';
    }
}
export class ValidationError extends Error {
    constructor(message) {
        super(message);
        this.name = 'ValidationError';
    }
}
/** Could not reach the server, or it failed (5xx). Safe to retry later; nothing is lost. */
export class NetworkError extends Error {
    constructor(message = 'Could not reach the server') {
        super(message);
        this.name = 'NetworkError';
    }
}
/** The server refused the session ('unauthenticated' | 'session_expired' | 'device_revoked' | 'forbidden' | 'locked'). */
export class AuthFailure extends Error {
    code;
    constructor(code, message) {
        super(message);
        this.code = code;
        this.name = 'AuthFailure';
    }
}
export class DeviceRevokedError extends Error {
    constructor() {
        super('This device was revoked by an administrator. Its local data has been erased.');
        this.name = 'DeviceRevokedError';
    }
}
//# sourceMappingURL=errors.js.map